import { GetRecordsResponseViewFragment } from 'generated/graphql';
import { mapFeedback } from 'v2/core/repository/edge-server/utils/records';
import { updateFeedbacks } from 'v2/core/services/records/updateFeedback';

interface GetMappedFeedbackRecordsFromResponseParams {
  response: GetRecordsResponseViewFragment;
  timezone: string;
}

export const getMappedFeedbackRecordsFromResponse = ({
  response,
  timezone,
}: GetMappedFeedbackRecordsFromResponseParams) => {
  const mappedRecords = mapFeedback(timezone, response?.records, undefined);
  return updateFeedbacks(mappedRecords);
};
